import { environment } from './environment.base';
export { environment };

environment.production = true;
environment.backendUrl = window.location.origin;
environment.showDarkMode = true;
environment.showVideoTab = true;
environment.signalingServerUrl = "wss://thejanetra.strayos.com";
environment.sentryUrl = "https://2ffbab50001d46fee443580951e0505c@sentry.strayos.com/12";
environment.name = 'theja';